<template>
	<div>
		<el-upload class="upload-demo g-m-t-10" ref="upload" :action="uploadUrl" :headers="headers" :on-change="handleChange"
			:before-upload="handleBeforeUpload" :file-list="uploadConfig.fileList" :on-success="uploadSuccess" :on-remove="removeSuccess">
			<el-button size="small" type="primary">点击上传</el-button>
		</el-upload>
		<p class="g-text-left remark-text g-font-12 g-m-t-15">{{uploadConfig.tip}}</p>
	</div>

</template>

<script>
	import config from "@/api/config.js"
	import {
		Base64
	} from '@/utils/base64.js';

	export default {
		name: "uploadBtn",
		props: {
			"uploadConfig": {
				type: Object,
				default: function() {
					return {
						tip: '支持上传：.jpg .png .gif文件，仅支持上传1个文件，每个文件大小不超过5MB',
						type: 'img',
						size: 1024 * 1024 * 5,
						fileList: [],
						fileType: ["jpg", "png", "gif"]
					}
				},
			}
		},
		data() {
			return {
				uploadUrl: config.baseUrl + '/blade-resource/oss/endpoint/put-file',
				fileList: []
			}
		},
		computed: {
			headers() {
				return {
					'Blade-Auth': 'bearer ' + this.$store.state.accessToken,
					'Authorization': 'Basic ' + Base64.encode('sword:sword_secret')
				}
			}
		},
		methods: {
			// 上传前校检格式和大小
			handleBeforeUpload(file) {
			  // 校检文件类型
			  if (this.uploadConfig.fileType) {
			    let fileExtension = "";
			    if (file.name.lastIndexOf(".") > -1) {
			      fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
			    }
			    const isTypeOk = this.uploadConfig.fileType.some((type) => {
			      if (file.type.indexOf(type) > -1) return true;
			      return !!(fileExtension && fileExtension.indexOf(type) > -1);
			    });
			    if (!isTypeOk) {
			      this.$message(`文件格式不正确, 请上传${this.uploadConfig.fileType.join("/")}格式文件!`,"error");
			      return false;
			    }
			  }
			  // 校检文件大小
			  if (this.uploadConfig.size) {
			    const isLt = file.size < this.uploadConfig.size;
			    if (!isLt) {
			      this.$message(`上传文件大小不能超过 ${this.uploadConfig.size/1024/1024} MB!`,"error");
			      return false;
			    }
			  }
			  return true;
			},
			handleChange(file, fileList) {

			},
			uploadSuccess(res, file, filelist) {
				console.log(res)
				if(filelist.length>1){
					this.$refs.upload.clearFiles();
					this.uploadConfig.fileList = [];
					this.uploadConfig.fileList.push(file);
					this.$forceUpdate();
				}
				this.$emit('uploadSuccess', res.data.link)
			},
			removeSuccess(file, fileLis) {
				this.$emit('removeSuccess', file)
			},
		},
	}
</script>

<style>
</style>
